import { getToken } from "@/utils/auth";
import Errors from "@/views/404";
import Appstore from "@/views/appstore/index";
import Lint from "@/views/enterprise/init";
import ForgetPassword from "@/views/forgetPassword/index";
import Login from "@/views/login/index";
import OAuth from "@/views/oauth/index";
import Register from "@/views/register/index";
/* 页面*/
import Transit from "@/views/transit/index";
import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);







/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {
    path: "/",
    name: "root",
    redirect: "/appstore"
  },
  {
    path: "/manage",
    name: "transit",
    component: Transit,
    meta: {
      requireAuth: true
    },
    hidden: true
  },
  {
    path: "/appstore",
    name: "appstore",
    component: Appstore,
    hidden: true
  },
  {
    path: "/oauth/callback",
    name: "OAuth",
    component: OAuth,
    hidden: true
  },
  {
    path: "/manage/register",
    name: "register",
    component: Register,
    hidden: true
  },
  {
    path: "/manage/login",
    name: "login",
    component: Login,
    hidden: true
  },
  {
    path: "/manage/forgetPassword",
    name: "forgetPassword",
    component: ForgetPassword,
    hidden: true
  },
  {
    path: "/404",
    name: "404",
    component: Errors,
    hidden: true
  },

  {
    path: "/manage/enterprise/init",
    name: "enterprise-init",
    meta: {
      requireAuth: true
    },
    component: Lint
  },
  // {
  //   path: "/manage/jointcloud",
  //   name: "enterprise-jointcloud",
  //   meta: {
  //     requireAuth: true
  //   },
  //   component: Jointcloud
  // },
  // {
  //   path: "/manage/enterprise/:enterpriseID/overview",
  //   name: "overview",
  //   props: true,
  //   meta: {
  //     icon: "overview",
  //     requiresAuth: true,
  //     switch: true
  //   },
  //   component: Layout,
  //   children: [
  //     {
  //       path: "index",
  //       name: "overviewAll",
  //       component: MyOrder,
  //       meta: {
  //         title: "总览",
  //         icon: "overview",
  //         requiresAuth: true,
  //         switch: true
  //       },
  //       hidden: true
  //     }
  //   ]
  // },
  // {
  //   path: "/manage/enterprise/:enterpriseID/appsManage",
  //   component: Layout,
  //   props: true,
  //   // redirect: 'details',
  //   name: "appsManage",
  //   meta: {
  //     icon: "apps-management",
  //     requiresAuth: true,
  //     switch: true
  //   },
  //   hidden: false,
  //   children: [
  //     {
  //       path: "",
  //       name: "apps",
  //       component: App,
  //       meta: {
  //         title: "应用管理",
  //         icon: "enterprise-application",
  //         requiresAuth: true,
  //         switch: true
  //       },
  //       hidden: false
  //     },
  //     {
  //       path: ":appID/:tabName",
  //       name: "appsEditorFrom",
  //       component: AppsEditorFrom,
  //       meta: { title: "应用编辑信息", requiresAuth: true },
  //       hidden: true
  //     }
  //   ]
  // },
  // {
  //   path: "/manage/enterprise/:enterpriseID/mybuyapps",
  //   name: "mybuyapps",
  //   props: true,
  //   redirect: "/manage/enterprise/:enterpriseID/mybuyapps/all",
  //   meta: {
  //     icon: "order",
  //     requiresAuth: true,
  //     switch: true
  //   },
  //   component: Layout,
  //   hidden: false,
  //   children: [
  //     {
  //       path: ":buyAppState",
  //       name: "mybuyappsAll",
  //       component: MyBuyApps,
  //       meta: {
  //         title: "企业应用",
  //         icon: "enterprise-application",
  //         requiresAuth: true,
  //         switch: true
  //       },
  //       hidden: false
  //     },
  //     {
  //       path: "details/:orderId",
  //       name: "mybuyappsAllDetails",
  //       component: MyBuyAppsAllDetails,
  //       meta: {
  //         title: "应用详情",
  //         icon: "order",
  //         requiresAuth: true
  //       },
  //       hidden: true
  //     }
  //   ]
  // },

  // {
  //   path: "/manage/enterprise/:enterpriseID/warning",
  //   name: "warning",
  //   props: true,
  //   meta: {
  //     icon: "warning",
  //     requiresAuth: true,
  //     switch: true
  //   },
  //   component: Layout,
  //   children: [
  //     {
  //       path: "info",
  //       name: "warningAll",
  //       component: MyOrder,
  //       meta: {
  //         title: "预警信息",
  //         icon: "warning",
  //         requiresAuth: true,
  //         switch: true
  //       },
  //       hidden: true
  //     }
  //   ]
  // },

  // {
  //   path: "/manage/enterprise/:enterpriseID/myorder",
  //   name: "myorder",
  //   props: true,
  //   // redirect: '/manage/enterprise/:enterpriseID/myorder/all',
  //   meta: {
  //     icon: "order",
  //     requiresAuth: true,
  //     switch: true
  //   },
  //   component: Layout,
  //   hidden: false,
  //   children: [
  //     {
  //       path: ":orderState",
  //       name: "myorderAll",
  //       component: MyOrder,
  //       meta: {
  //         title: "企业订单",
  //         icon: "order",
  //         requiresAuth: true,
  //         switch: true
  //       },
  //       hidden: true
  //     },
  //     {
  //       path: "details/:orderId",
  //       name: "myorderDetails",
  //       component: MyOrderDetails,
  //       meta: {
  //         title: "订单详情",
  //         icon: "order",
  //         requiresAuth: true
  //       },
  //       hidden: true
  //     }
  //   ]
  // },
  // {
  //   path: "/manage/enterprise/:enterpriseID/orderManage",
  //   component: Layout,
  //   props: true,
  //   // redirect: 'details',
  //   name: "orderManage",
  //   meta: {
  //     icon: "enterprise-shop",
  //     requiresAuth: true,
  //     switch: true
  //   },
  //   hidden: false,
  //   children: [
  //     {
  //       path: ":orderManageType",
  //       name: "orderManageAll",
  //       meta: {
  //         title: "企业订单",
  //         icon: "total-yesterday",
  //         requireAuth: true,
  //         switch: true
  //       },
  //       component: OrderManage
  //     },
  //     {
  //       path: ":orderState/details/:orderId",
  //       name: "orderDetails",
  //       component: OrderDetails,
  //       meta: {
  //         title: "订单管理详情",
  //         icon: "order",
  //         requiresAuth: true
  //       },
  //       hidden: true
  //     }
  //   ]
  // },

  // {
  //   path: "/manage/enterprise/:enterpriseID",
  //   component: Layout,
  //   props: true,
  //   // redirect: 'details',
  //   name: "Stores",
  //   meta: {
  //     title: "商店管理",
  //     icon: "shop-management",
  //     requiresAuth: true,
  //     switch: true
  //   },
  //   hidden: false,
  //   children: [


  //     {
  //       path: "classification",
  //       name: "classification",
  //       component: AppClassification,
  //       meta: {
  //         title: "应用管理",
  //         icon: "product-cate",
  //         requiresAuth: true,
  //         switch: true
  //       },
  //       hidden: false
  //     },
  //     {
  //       path: "classification",
  //       name: "classification",
  //       component: AppClassification,
  //       meta: {
  //         title: "订单管理",
  //         icon: "order",
  //         requiresAuth: true,
  //         switch: true
  //       },
  //       hidden: false
  //     },
  //     {
  //       path: "classification",
  //       name: "classification",
  //       component: AppClassification,
  //       meta: {
  //         title: "客户管理",
  //         icon: "customer-management",
  //         requiresAuth: true,
  //         switch: true
  //       },
  //       hidden: false
  //     },
  //     {
  //       path: "details",
  //       name: "details",
  //       component: StoreDetails,
  //       meta: {
  //         title: "商店设置",
  //         icon: "store-settings",
  //         requiresAuth: true,
  //         switch: true
  //       },
  //       hidden: false
  //     },
  //     {
  //       path: "editorClassification/:appTypeID/form",
  //       name: "classificationEditorFrom",
  //       component: AppClassificationEditorFrom,
  //       meta: { title: "编辑产品信息", requiresAuth: true },
  //       hidden: true
  //     }
  //   ]
  // },

  // {
  //   path: "/manage/enterprise/:enterpriseID/deliverManage",
  //   component: Layout,
  //   props: true,
  //   // redirect: 'details',
  //   name: "deliverManage",
  //   meta: {
  //     title: "交付管理",
  //     icon: "delivery-management",
  //     requiresAuth: true,
  //     switch: true
  //   },
  //   hidden: true,
  //   children: [
  //     {
  //       path: "apps",
  //       name: "deliveryAppsrManage",
  //       component: AppsManage,
  //       meta: {
  //         title: "交付应用管理",
  //         icon: "enterprise-application",
  //         requiresAuth: true,
  //         switch: true
  //       },
  //       hidden: false
  //     },
  //     {
  //       path: "environment",
  //       name: "deliveryEnvironmentManage",
  //       component: AppsManage,
  //       meta: {
  //         title: "交付环境管理",
  //         icon: "environment",
  //         requiresAuth: true,
  //         switch: true
  //       },
  //       hidden: false
  //     },
  //     {
  //       path: "customer",
  //       name: "customerManage",
  //       component: CustomerManage,
  //       meta: {
  //         title: "租户管理",
  //         icon: "tenant-management",
  //         requiresAuth: true,
  //         switch: true
  //       },
  //       hidden: false
  //     },
  //     {
  //       path: "info",
  //       name: "warningAll",
  //       component: MyOrder,
  //       meta: {
  //         title: "预警信息",
  //         icon: "warning",
  //         requiresAuth: true,
  //         switch: true
  //       },
  //       hidden: true
  //     },
  //     {
  //       path: "apps/:deliverID/detail",
  //       name: "deliverDetails",
  //       component: DeliverDetails,
  //       meta: {
  //         title: "详情",
  //         icon: "del-management",
  //         requiresAuth: true
  //       },
  //       hidden: true
  //     }
  //   ]
  // },

  // {
  //   path: "/manage/enterprise/:enterpriseID",
  //   component: Layout,
  //   redirect: "",
  //   props: true,
  //   // name: 'enterpriseInformation',
  //   meta: {
  //     title: "企业管理",
  //     icon: "enterprise-management",
  //     requireAuth: true,
  //     switch: true
  //   },
  //   hidden: false,
  //   children: [
  //     {
  //       path: "",
  //       name: "home",
  //       component: Home,
  //       meta: {
  //         title: "企业管理主页",
  //         icon: "order",
  //         requiresAuth: true
  //       },
  //       hidden: true
  //     },
  //     {
  //       path: "basis",
  //       name: "basis",
  //       component: Basis,
  //       meta: {
  //         title: "基础设置",
  //         icon: "infrastructure",
  //         requireAuth: true,
  //         switch: true
  //       },
  //       hidden: false
  //     },
  //     {
  //       path: "jointCloud",
  //       name: "jointCloud",
  //       component: JointCloud,
  //       meta: {
  //         title: "企业积分",
  //         icon: "enterprise-integration",
  //         requireAuth: true,
  //         switch: true
  //       },
  //       hidden: false
  //     },
  //     {
  //       path: "jointClouds",
  //       name: "jointClouds",
  //       component: JointCloud,
  //       meta: {
  //         title: "组织机构",
  //         icon: "organization",
  //         requireAuth: true,
  //         switch: true
  //       },
  //       hidden: false
  //     },
  //     {
  //       path: "jointClouds1",
  //       name: "jointClouds1",
  //       component: JointCloud,
  //       meta: {
  //         title: "子用户",
  //         icon: "user-set",
  //         requireAuth: true,
  //         switch: true
  //       },
  //       hidden: false
  //     },
  //     {
  //       path: "jointClouds2",
  //       name: "jointClouds2",
  //       component: JointCloud,
  //       meta: {
  //         title: "角色管理",
  //         icon: "role-management",
  //         requireAuth: true,
  //         switch: true
  //       },
  //       hidden: false
  //     },
  //     // {
  //     //   path: "addJointCloud",
  //     //   name: "addJointCloud",
  //     //   component: AddJointCloud,
  //     //   meta: { title: "注册联合云", icon: "order", requireAuth: true },
  //     //   hidden: true
  //     // },
  //     // {
  //     //   path: "userManagement",
  //     //   name: "userManagement",
  //     //   component: UserManagement,
  //     //   meta: {
  //     //     title: "成员管理",
  //     //     icon: "product-cate",
  //     //     requireAuth: true,
  //     //     switch: true
  //     //   },
  //     //   hidden: false
  //     // },
  //     {
  //       path: "openStore",
  //       name: "openStore",
  //       component: OpenStore,
  //       meta: {
  //         title: "申请开通商店",
  //         icon: "apply-opening-shop",
  //         requireAuth: true,
  //         switch: true
  //       },
  //       hidden: false
  //     }
  //   ]
  // },
  // {
  //   path: "/manage/admin/enterpriseManagement",
  //   component: AdminLayout,
  //   meta: { requireAuth: true, switch: true },
  //   hidden: true,
  //   children: [
  //     {
  //       path: "",
  //       name: "adminEnterpriseManagement",
  //       component: AdminEnterpriseManagement,
  //       meta: {
  //         title: "企业管理",
  //         icon: "enterprise-management",
  //         requireAuth: true,
  //         switch: true
  //       },
  //       hidden: true
  //     },
  //     {
  //       path: ":enterpriseID/form",
  //       name: "adminEnterpriseEditorFrom",
  //       component: AdminEnterpriseEditorFrom,
  //       meta: { title: "企业编辑信息", requiresAuth: true },
  //       hidden: true
  //     }
  //   ]
  // },
  // {
  //   path: "/manage/admin/userManagement",
  //   component: AdminLayout,
  //   meta: { requireAuth: true, switch: true },
  //   hidden: false,
  //   children: [
  //     {
  //       path: "",
  //       name: "adminUserManagement",
  //       component: AdminUserManagement,
  //       meta: {
  //         title: "用户管理",
  //         icon: "user-management",
  //         requireAuth: true,
  //         switch: true
  //       },
  //       hidden: false
  //     },
  //     {
  //       path: ":userID/form",
  //       name: "adminUserEditorFrom",
  //       component: AdminUserEditorFrom,
  //       meta: { title: "用户编辑信息", requiresAuth: true },
  //       hidden: true
  //     }
  //   ]
  // },
  // {
  //   path: "/manage/admin/appLabelManagement",
  //   // 设置为AdminLayout侧边栏使用的是管理员的布局。
  //   component: AdminLayout,
  //   meta: { requireAuth: true, switch: true },
  //   hidden: true,
  //   children: [
  //     {
  //       path: "",
  //       name: "adminAppLabelManagement",
  //       component: AdminAppLabelManagement,
  //       meta: {
  //         title: "应用标签管理",
  //         icon: "tags-management",
  //         requireAuth: true,
  //         switch: true
  //       },
  //       hidden: true
  //     },
  //     {
  //       path: ":appTagId/form",
  //       name: "adminAppLabelEditorFrom",
  //       component: AdminAppLabelEditorFrom,
  //       meta: { title: "应用标签编辑信息", requiresAuth: true },
  //       hidden: true
  //     }
  //   ]
  // },
  // {
  //   path: "/manage/enterprises/:enterpriseID/",
  //   component: Pay,
  //   name: "pay-orders",
  //   meta: {
  //     requireAuth: true
  //   },
  //   hidden: true,
  //   children: [
  //     {
  //       path: "confirmOrder",
  //       name: "confirmOrder",
  //       component: ConfirmOrder,
  //       meta: {
  //         title: "SaaS服务订单支付",
  //         active: 1
  //       },
  //       hidden: true
  //     }
  //   ]
  // },
  // {
  //   path: "/manage/enterprises/:enterpriseID/uorders/:orderID",
  //   component: Pay,
  //   name: "pay-uorders",
  //   meta: {
  //     requireAuth: true
  //   },
  //   hidden: true,
  //   children: [
  //     {
  //       path: "pay",
  //       name: "orderpay",
  //       component: payOrder,
  //       meta: {
  //         title: "支付",
  //         active: 2
  //       },
  //       hidden: true
  //     },
  //     {
  //       path: "statusOrder",
  //       name: "statusOrder",
  //       component: statusOrder,
  //       meta: {
  //         title: "状态",
  //         active: 3
  //       },
  //       hidden: true
  //     }
  //   ]
  // },
  { path: "*", redirect: "/404", hidden: true }
];

var router = new Router({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      resolve({ x: 0, y: 0 });
      setTimeout(() => {
        resolve({ x: 0, y: 0 });
      }, 500);
    });
  },
  routes: constantRouterMap
});
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});
router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {
    // 判断该路由是否需要登录权限
    console.log("getToken", getToken());
    if (getToken() && getToken() != "") {
      next();
    } else {
      next({
        name: "login",
        query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
      });
    }
  } else {
    next();
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js